import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../providers/ProviderAppContainer";
import ProgressiveControl from "../common/ProgressiveControl";
import ConfirmationWrapper from "../common/ConfirmationWrapper";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import IconButton from "../common/IconButton";
import { AUTHORITIES } from "../../constants";
import { TEXT_NORMAL, TEXT_SMALL } from "../../style";

export default function BatchStudent({ id, user_id, full_name, roll_no, batchId, setStudents, updatingViewIndex }) {
    const navigate = useNavigate();
    const { requestAPI, showToast } = useAppContext();
    const [removing, setRemoving] = useState();

    const removeStudent = useCallback(() => {
        requestAPI({
            requestPath: `batches/${batchId}/users/${user_id}`,
            requestMethod: "DELETE",
            setLoading: setRemoving,
            parseResponseBody: false,
            onResponseReceieved: (_, responseCode) => {
                if (responseCode === 204) {
                    showToast({ severity: "success", summary: "Removed", detail: "Student Removed From Batch", life: 1000 });
                    setStudents((prev) => prev?.filter((student) => student?.id !== id));
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: "Failed To Remove Student !", life: 2000 });
                }
            },
        });
    }, [batchId, id, requestAPI, setStudents, showToast, user_id]);

    return (
        <div className="flex gap-3 align-items-center border-1 border-gray-300 border-round py-2 px-3">
            <div
                className="flex flex-column flex-1 gap-1 overflow-hidden cursor-pointer"
                onClick={() => {
                    if (!updatingViewIndex) navigate(`/manage-users/${user_id}`);
                }}
            >
                <span className={`${TEXT_NORMAL} font-semibold`}>
                    {roll_no != null ? `${roll_no}. ` : null}
                    {full_name || "—"}
                </span>
                <span className={TEXT_SMALL}>User #{user_id}</span>
            </div>

            {!!updatingViewIndex && <IconButton icon={"pi-equals"} color={"text-indigo-800"} />}

            {!updatingViewIndex && (
                <HasRequiredAuthority requiredAuthority={AUTHORITIES.ASSIGN_BATCH_STUDENT}>
                    <ProgressiveControl
                        loading={removing}
                        control={
                            <ConfirmationWrapper action={removeStudent}>
                                <i className="pi pi-trash" />
                            </ConfirmationWrapper>
                        }
                    />
                </HasRequiredAuthority>
            )}
        </div>
    );
}
